import graphql__c95fa3e897be240768ad from "./__generated__/ProfileSettings_user.graphql.js";
import graphql__5b4e181d0fa617fb6f9e from "./__generated__/ProfileSettings_notificationCycles.graphql.js";import { PureComponent } from "react";
import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import { defineMessages, injectIntl } from "react-intl";

import ProfileSettingsForm from "./ProfileSettingsForm";

class ProfileSettings extends PureComponent {
  get labels() {
    const { formatMessage } = this.props.intl;

    return {
      title: formatMessage(intlMessages.title)
    };
  }

  render() {
    const { user, notificationCycles } = this.props;
    const { title } = this.labels;

    return (
      <div className="box padding-lg">
        <div className="row">
          <div className="col-12">
            <h2 className="text-subtitle-page margin-bottom-sm">{title}</h2>

            <ProfileSettingsForm {...{ user, notificationCycles }} />
          </div>
        </div>
      </div>
    );
  }
}

export default createFragmentContainer(injectIntl(ProfileSettings), {
  user: graphql__c95fa3e897be240768ad,
  notificationCycles: graphql__5b4e181d0fa617fb6f9e
});

const intlMessages = defineMessages({
  title: {
    id: "profile.settings.title",
    defaultMessage: "Paramètres du compte"
  }
});
